import React from 'react'
import { Mutation, Query } from 'react-apollo'
import { gql } from 'apollo-boost'
import { Field, Formik } from 'formik'
import * as yup from 'yup'
import ModelSelect from '../Models/Select'
import UserSelect from '../Users/Select'
import Text from '../Text'
import Button from '../Button'
import Loading from '../Loading'
import Form, { Group, Heading } from '../Form'

const GET_BEACON = gql`
  query beacon($id: ID!) {
    beacon(id: $id) {
      id
      tag
      model {
        id
      }
      owner {
        id
      }
      assignee {
        id
      }
    }
  }
`

const UPDATE_BEACON = gql`
  mutation updateBeacon(
  $id: ID!
  $model: ID!
  $owner: ID
  $assignee: ID
  ) {
    updateBeacon(
      id: $id
      model: $model
      owner: $owner
      assignee: $assignee
    ) {
      id
    }
  }
`

const validationSchema = yup.object().shape({
  id: yup.string().required('ID is required'),
  tag: yup.string().required('Tag is required'),
  model: yup.string(),
  owner: yup.string()
})

const onSubmit = (values, {setSubmitting}, updateBeacon) => {
  updateBeacon({variables: values})
  setSubmitting(false)
}

const Update = ({id, onCompleted, onError}) =>
  <Query
    query={GET_BEACON}
    variables={{id}}
    fetchPolicy='cache-and-network'>
    {({loading, error, data}) => {
      if (loading) return <Loading />
      if (error) return <Text error>{error.message}</Text>
      if (!data.beacon) return <Text>Nothing was found!</Text>

      return (
        <Mutation
          mutation={UPDATE_BEACON}
          onCompleted={onCompleted}
          onError={onError}>
          {(updateBeacon, {error, loading}) =>
            <Formik
              initialValues={{
                id: data.beacon.id || '',
                tag: data.beacon.tag || '',
                model: (data.beacon.model && data.beacon.model.id) || '',
                owner: (data.beacon.owner && data.beacon.owner.id) || '',
                assignee: (data.beacon.assignee && data.beacon.assignee.id) || ''
              }}
              validationSchema={validationSchema}
              onSubmit={(values, actions) => onSubmit(values, actions, updateBeacon)}>
              {({isSubmitting, values}) =>
                <Form>
                  <Text h2 secondary mb={3}>{values.tag}</Text>

                  <Heading>General</Heading>
                  <Field component={ModelSelect} name='model' placeholder='Select a model...' required />

                  <Heading>Users</Heading>
                  <Group>
                    <Field component={UserSelect} name='owner' placeholder='Select an owner...' />
                    <Field component={UserSelect} name='assignee' placeholder='Select an assignee...' />
                  </Group>

                  <Button type='submit' fluid disabled={loading || isSubmitting}>Save</Button>
                </Form>
              }
            </Formik>
          }
        </Mutation>
      )
    }}
  </Query>

export default Update


// WEBPACK FOOTER //
// ./src/components/Beacons/Update.js